const dev = {
    API_ENDPOINT_URL: 'https://oracle.maffle.it/sicignanostudioodontoiatrico/sviluppo'
};

const prod = {
    API_ENDPOINT_URL: 'https://ec2.maffle.it/sicignanostudioodontoiatrico/produzione'
};

const getEnv = () => {
    console.log("PROCESS ENV", process.env.REACT_APP_ENV?.trim())
    switch (process.env.REACT_APP_ENV?.trim()) {
        case 'sviluppo':
            return dev
        case 'produzione':
            return prod
        default:
            return {
                API_ENDPOINT_URL: 'http://localhost:1337'
            };
    }
}

export const env = getEnv()
